import { Component } from '@angular/core';

import { User, Master } from '@providers/advance_providers';

import { AboutPage } from '../about/about';
import { ContactPage } from '../contact/contact';
import { HomePage } from '../home/home';
import { ListEmployeePage } from '../list_employee/page';
import { OrganizationPage } from '../organization/page';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = HomePage;
  tab2Root = AboutPage;
  tab3Root = ContactPage;
  tab4Root = ListEmployeePage;
  tab5Root = OrganizationPage;

  akses:any={};

  constructor(
    public userApi : User
  ) {
   this.akses = this.userApi.akses;
  }
}



// WEBPACK FOOTER //
// ./src/pages/advance_mobile/tabs/tabs.ts